<template>
  <section v-loading="listLoading" class="page-container">
    <div ref="toolbar" class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-select v-model="filters.companyId" filterable clearable placeholder="请选择公司">
            <el-option
              v-for="item in companiesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.positionId" filterable clearable placeholder="请选择职位类型">
            <el-option
              v-for="item in positionsList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.status" clearable placeholder="请选择状态" @change="list">
            <el-option label="正常" value="0" />
            <el-option label="删除" value="1" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="list"> 查询 </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div ref="mainContent" :style="{ height: mainHeight }">
      <el-table
        v-loading="listLoading"
        height="100%"
        :data="results"
        highlight-current-row
        stripe
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column prop="topicId" label="id"/>
        <el-table-column prop="createTime" label="创建时间">
          <template slot-scope="scope">
            {{ scope.row.createTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="头像" width="70">
          <template slot-scope="scope">
            <img :src="scope.row.user.avatar" style="width: 50px" />
          </template>>
        </el-table-column>
        <el-table-column label="呢称">
          <template slot-scope="scope">
            {{scope.row.user.nickname}}
          </template>>
        </el-table-column>
        <el-table-column prop="company" label="企业"/>
        <el-table-column prop="positionName" label="招聘职位"/>
        <el-table-column prop="viewCount" label="查看次数"/>
        <el-table-column prop="applyCount" label="申请次数"/>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-dropdown size="mini" trigger="hover" placement="bottom" @command="handleCommand">
              <el-button type="primary">
                操作<i class="el-icon-arrow-down el-icon--right"/>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{ cmd: 'view', row: scope.row }">
                  详情
                </el-dropdown-item>
                <el-dropdown-item :command="{ cmd: 'priority', row: scope.row }">
                  优先展示
                </el-dropdown-item>
                <el-dropdown-item :command="{ cmd: 'delete', row: scope.row }">
                  删除
                </el-dropdown-item>
                <el-dropdown-item :command="{ cmd: 'undelete', row: scope.row }">
                    取消删除
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div ref="pagebar" class="pagebar">
      <el-pagination
        :page-sizes="[20, 50, 100, 300]"
        :current-page="page.page"
        :page-size="page.limit"
        :total="page.total"
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handlePageChange"
        @size-change="handleLimitChange"
      />
    </div>

    <el-dialog :visible.sync="viewVisible" :close-on-click-modal="false" title="详情">
      <el-descriptions column="1" size="mini">
        <el-descriptions-item label="Lever">{{ viewWorker.leverName }}</el-descriptions-item>
        <el-descriptions-item label="Company">{{ viewWorker.company }}</el-descriptions-item>
        <el-descriptions-item label="CompanyWebsite">{{ viewWorker.companyWebsite }}</el-descriptions-item>
        <el-descriptions-item label="CompanySize">{{ viewWorker.companySizeName }}</el-descriptions-item>
        <el-descriptions-item label="Position">{{ viewWorker.positionName }}</el-descriptions-item>
        <el-descriptions-item label="Salary">${{ viewWorker.minSalary }} ~ ${{ viewWorker.maxSalary }}</el-descriptions-item>
        <el-descriptions-item label="OfficeMode">{{ viewWorker.officeModeName }}</el-descriptions-item>
        <el-descriptions-item label="WorkType">{{ viewWorker.workTypeName }}</el-descriptions-item>
        <el-descriptions-item label="Base">{{ viewWorker.base }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions column="1" size="mini" direction="vertical">
        <el-descriptions-item label="Company Info">{{ viewWorker.content5 }}</el-descriptions-item>
        <el-descriptions-item label="Job Description">{{ viewWorker.content }}</el-descriptions-item>
        <el-descriptions-item label="Job Requirements">{{ viewWorker.content2 }}</el-descriptions-item>
        <el-descriptions-item label="Benefits">{{ viewWorker.content3 }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions column="1" size="mini">
        <el-descriptions-item v-if="viewWorker.email" label="Email">{{ viewWorker.email }}</el-descriptions-item>
        <el-descriptions-item v-if="viewWorker.phone" label="Phone">{{ viewWorker.phone }}</el-descriptions-item>
        <el-descriptions-item v-if="viewWorker.telegram" label="Telegram">{{ viewWorker.telegram }}</el-descriptions-item>
        <el-descriptions-item v-if="viewWorker.wechat" label="Wechat">{{ viewWorker.wechat }}</el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="viewVisible = false"> 取消</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
import mainHeight from "@/utils/mainHeight";

export default {
  name: "Topics",
  data() {
    return {
      mainHeight: "300px",
      results: [],
      listLoading: false,
      page: {},
      filters: {
        status: "0",
      },
      selectedRows: [],
      viewVisible: false,
      viewWorker: {},
      companiesList: [],
      positionsList: [],
    };
  },
  mounted() {
    mainHeight(this);
    this.getPositions();
    this.getCompanies();
    this.list();
  },
  methods: {
    getPositions() {
      const params = Object.assign({
        page: 1,
        limit: 1000000000,
      });
      this.axios.form("/api/admin/position/list", params).then((data) => {
        this.positionsList = data.results;
      });
    },
    getCompanies() {
      const params = Object.assign({
        page: 1,
        limit: 1000000000,
      });
      this.axios.form("/api/admin/company/listall", params).then((data) => {
        this.companiesList = data.results;
      });
    },
    list() {
      const me = this;
      me.listLoading = true;
      const params = Object.assign(me.filters, {
        page: me.page.page,
        limit: me.page.limit,
      });
      this.axios
        .form("/api/admin/worker/list", params)
        .then((data) => {
          me.results = data.results;
          me.page = data.page;
        })
        .finally(() => {
          me.listLoading = false;
        });
    },
    handlePageChange(val) {
      this.page.page = val;
      this.list();
    },
    handleLimitChange(val) {
      this.page.limit = val;
      this.list();
    },
    deleteSubmit(topicId) {
      const me = this;
      this.$confirm("是否确认删除该话题?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          me.axios
            .form("/api/admin/worker/delete", {id: topicId})
            .then(function () {
              me.$message({message: "删除成功", type: "success"});
              me.list();
            })
            .catch(function (err) {
              me.$notify.error({title: "错误", message: err.message || err});
            });
        })
        .catch(function () {
          me.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async prioritySubmit(topicID) {
      try {
        await this.axios.form("/api/admin/worker/priority", {id: topicID});
        this.list();
        this.$message({message: "优先展示成功", type: "success"});
      } catch (err) {
        this.$notify.error({title: "错误", message: err.message || err});
      }
    },
    async undeleteSubmit(topicId) {
      try {
        await this.axios.form("/api/admin/worker/undelete", {id: topicId});
        this.list();
        this.$message({message: "取消删除成功", type: "success"});
      } catch (err) {
        this.$notify.error({title: "错误", message: err.message || err});
      }
    },
    async recommend(id) {
      try {
        await this.axios.form("/api/admin/worker/recommend", {
          id,
        });
        this.$message({message: "推荐成功", type: "success"});
        this.list();
      } catch (e) {
        this.$notify.error({title: "错误", message: e.message});
      }
    },
    async cancelRecommend(id) {
      try {
        await this.axios.delete("/api/admin/worker/recommend", {
          params: {
            id,
          },
        });
        this.$message({message: "取消推荐成功", type: "success"});
        this.list();
      } catch (e) {
        this.$notify.error({title: "错误", message: e.message});
      }
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    handleView(row) {
      const me = this;
      me.viewWorker = row;
      me.viewVisible = true;
    },
    handleCommand(cmd) {
      if (cmd.cmd === "view") {
        this.handleView(cmd.row);
      }else if(cmd.cmd==="priority"){
        this.prioritySubmit(cmd.row.topicId);
      } else if (cmd.cmd === "delete") {
        this.deleteSubmit(cmd.row.topicId);
      } else if (cmd.cmd === "undelete") {
        this.undeleteSubmit(cmd.row.topicId);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.topics {
  width: 100%;
  padding: 0;
  margin: 0;
  overflow-y: auto;

  .topic-item:not(:last-child) {
    border-bottom: solid 1px rgba(140, 147, 157, 0.14);
  }

  .topic-item {
    width: 100%;
    padding: 20px 10px;
    display: flex;
    flex: 1;

    .topic-main {
      width: 100%;
      margin-left: 10px;
      font-size: 14px;
      a {
        font-size: 14px;
      }

      .topic-header {
        .topic-nickname {
          font-size: 16px;
          font-weight: 600;
          color: #606266;
        }

        .topic-info {
          margin-left: 10px;
          float: right;
          cursor: pointer;
        }
      }

      .topic-metadata {
        margin: 12px 0;
        color: #8590a6;

        .topic-metadata-item {
          margin-right: 12px;

          &.topic-title-link {
            color: #1482f0;
          }
          &.node {
          }
          &.tag {
          }
        }
      }

      .topic-title {
        margin: 12px 0;
        a {
          font-size: 16px;
          font-weight: 600;
          color: #000;
        }
      }

      .topic-summary {
        margin: 12px 0;
        color: #525252;
      }

      .topic-image-list {
        margin: 12px 0;
        padding: 0;
        li {
          cursor: pointer;
          border: 1px dashed #ddd;
          text-align: center;

          // 图片尺寸
          $image-size: 120px;

          display: inline-block;
          vertical-align: middle;
          width: $image-size;
          height: $image-size;
          line-height: $image-size;
          margin: 0 8px 8px 0;
          background-color: #e8e8e8;
          background-size: 32px 32px;
          background-position: 50%;
          background-repeat: no-repeat;
          overflow: hidden;
          position: relative;

          .image-item {
            display: block;
            width: $image-size;
            height: $image-size;
            overflow: hidden;
            transform-style: preserve-3d;

            & > img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              transition: all 0.5s ease-out 0.1s;

              &:hover {
                transform: matrix(1.04, 0, 0, 1.04, 0, 0);
                backface-visibility: hidden;
              }
            }
          }
        }
      }

      .topic-actions {
        margin-top: 20px;
        .action-item {
          margin-right: 20px;
          color: #1482f0;
          font-weight: 500;
        }
      }
    }
  }
}
</style>
